import {
  initialState,
  Actions,
  State,
  EDIT_ELEMENT,
  EDIT_ELEMENT_SUCCESS,
  EDIT_ELEMENT_ERROR,
  RESET_EDIT_ELEMENT,
} from '../../types/element/edit'

const reducers = (state = initialState, action: Actions<any>): State<any> => {
  switch (action.type) {
    case EDIT_ELEMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_ELEMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_ELEMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_ELEMENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
